<template>
  <div>
    <div>
      <div class="page-slider">
        <input-container
          collection="categories"
          :class="categoryClass"
          ref="category"
          @proceedLocation="handleProceedLocation"
        ></input-container>
        <input-container
          v-if="category >= 0"
          collection="locations"
          :class="locationClass"
          :category="category"
          :categoryName="categoryName"
          @proceedProduct="openModalBooking"
          @back="handleBackButton"
        ></input-container>
      </div>
    </div>
  </div>
</template>

<script>
import InputContainer from "./InputContainer";
import { setTimeout } from "timers";
export default {
  name: "input-main",
  components: {
    InputContainer
  },
  data: () => ({
    category: -1,
    location: -1,
    categoryClass: "page-slider__item",
    locationClass: "page-slider__item",
    categoryName: ""
  }),
  mounted() {
    this.resetOrder();
  },
  methods: {
    handleBackButton() {
      this.$refs.category.$el.style.display = "block";
      setTimeout(() => {
        this.resetOrder();
      }, 100);
    },
    handleProceedLocation({ id, name }) {
      this.category = id;
      this.categoryClass = "page-slider__item slide-out";
      this.categoryName = name;
      setTimeout(() => {
        this.$refs.category.$el.style.display = "none";
      }, 400);
    },
    openModalBooking({ id }) {
      this.location = id;
      this.$emit("response", {
        location: this.location,
        category: this.category
      });
    },
    resetOrder() {
      this.category = -1;
      this.location = -1;
      this.categoryClass = "page-slider__item";
      this.categoryName = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 20px;
  &-slider {
    display: flex;
    &__item {
      transition: all 0.4s ease-out;
      &.slide-out {
        margin-left: -120%;
        margin-right: 20%;
      }
    }
  }
}
@media (max-width: 769px) {
  .page {
    padding: 10px;
  }
}
</style>
